import { LANDING_LOC_TEXTS, LOCALIZATION_TEXTS } from './index';

export const getLanguageStrings = (lang) => {
  // check existence of given language in lang pack
  const loginLang = lang in LOCALIZATION_TEXTS ? LOCALIZATION_TEXTS[lang] : LOCALIZATION_TEXTS.us;
  const landingLang = lang in LANDING_LOC_TEXTS ? LANDING_LOC_TEXTS[lang] : LANDING_LOC_TEXTS.us;

  return {
    ...loginLang,
    launchingRCM: landingLang,
  };
};
